import { render, staticRenderFns } from "./dialog-OCEAN.vue?vue&type=template&id=bc0dfd3c&scoped=true"
import script from "./dialog-OCEAN.vue?vue&type=script&lang=ts"
export * from "./dialog-OCEAN.vue?vue&type=script&lang=ts"
import style0 from "./dialog-OCEAN.vue?vue&type=style&index=0&id=bc0dfd3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0dfd3c",
  null
  
)

export default component.exports